import script from "./calendar.vue?vue&type=script&setup=true&lang=js"
export * from "./calendar.vue?vue&type=script&setup=true&lang=js"

import "./calendar.vue?vue&type=style&index=0&id=f6864c1c&scoped=true&lang=css"
import "./calendar.vue?vue&type=style&index=1&id=f6864c1c&lang=css"

import exportComponent from "D:\\WORK_At_Home\\kaikbSource\\restaurant-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6864c1c"]])

export default __exports__